import { render, staticRenderFns } from "./PhotoCrop.vue?vue&type=template&id=1b7f1542&"
import script from "./PhotoCrop.vue?vue&type=script&lang=js&"
export * from "./PhotoCrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports